/**
 * This file is a part of Amblique's projects.
 *
 * Copyright © Amblique - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 */

import {forwardRef} from 'react';
import PropTypes from 'prop-types';
import {pick} from 'lodash';

import {Box, Heading} from '@salesforce/retail-react-app/app/components/shared/ui';

import {ProductSwiper} from '@amblique/base/app/components/shared/swiper/product-swiper';

/**
 * @override
 *  - Utilize the standard `ProductSwiper` component
 */
const ProductScroller = forwardRef(({isLoading, header, title, products, productTileProps, ...props}, ref) => {
  const swiperProps = pick(props, Object.keys(ProductSwiper.propTypes));
  const willRender = products?.length > 0 || !!props.fallback;

  return (
    <Box ref={ref}>
      {willRender && title && !header && !isLoading && (
        <Heading as="h2" fontSize="2rem" fontWeight="500" mb="1.25rem" textAlign="center">
          {title}
        </Heading>
      )}

      {willRender && !title && !isLoading && (typeof header === 'function' ? header() : header)}

      {willRender && <ProductSwiper products={products} slideProps={productTileProps} {...swiperProps} />}
    </Box>
  );
});

ProductScroller.displayName = 'ProductScroller';

ProductScroller.propTypes = {
  ...ProductSwiper.propTypes,

  header: PropTypes.any,
  title: PropTypes.any,
  isLoading: PropTypes.bool,
  products: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
    PropTypes.arrayOf(PropTypes.object)
  ]),
  productTileProps: PropTypes.oneOfType([PropTypes.func, PropTypes.object]),
};

export default ProductScroller;
